import React from 'react';
import { NavLink } from 'react-router-dom';

import Expandable from 'components/global/application/Expandable';

import './AboutDropMenu.sass';

interface Props {
    showing: boolean;    // used to toggle display and switch content; component only displays with truthy values
    mouseHovered(event: React.MouseEvent<any>): void;   // methods to update parent so it knows when its safe to clear hoveredItem
    mouseUnHovered(event: React.MouseEvent<any>): void; // ^-- same
}

const AboutDropMenu: React.StatelessComponent<Props> = (props: Props) => {
    return(
        <Expandable
            direction="vertical"
            maxHeight="22em"
            expanded={props.showing}
            onMouseEnter={props.mouseHovered}
            onMouseLeave={props.mouseUnHovered}
            id="submenu"
            className="AboutDropMenu-container"
        >
            <div className="Padding-container">
                <div className="Dropmenu-column">
                    <span className="Category-header" ><NavLink exact to="/gruhn-guitars-story/">Our Story</NavLink></span>
                    <span className="Category-header" ><NavLink exact to="/users/george/">George Gruhn</NavLink></span>
                    <span className="Category-header" ><NavLink exact to="/gruhn-guitars-staff/">Staff</NavLink></span>
                    <span className="Category-header" ><NavLink exact to="/repair-shop/">Repair Shop</NavLink></span>
                    <span className="Category-header" ><NavLink exact to="/store-tour/">Online Tour</NavLink></span>
                    {/* <span className="Category-header" ><NavLink exact to="/videos/">Videos</NavLink></span> */}
                    <span className="Category-header" ><a href="/want-file">Want File</a></span>
                    <span className="Category-header" ><NavLink exact to="/store-policies/">Store Policies</NavLink></span>
                    <span className="Category-header" ><NavLink exact to="/contactdirections/">Contact Us</NavLink></span>
                </div>
            </div>
        </Expandable>
    );
};

export default AboutDropMenu;



// WEBPACK FOOTER //
// ./src/components/global/application/nav/AboutDropMenu.tsx